export default __webpack_public_path__ + "static/media/Logo-Medway.7dcda562.svg";